let insightsActive

$('#insightsTabs li').each(function () {
  const href = $(this).find('a.nav-link').attr('href')
  let strArr = href.split('')

  if ($(this).find('a.nav-link').attr('href') === window.location.hash) {
    $(this).addClass('active')

    insightsActive = true
  }
})

if (!insightsActive) {
  const audience = $('#insightsTabs li').find('a.nav-link[href="#audience"]')

  audience.parent().addClass('active')
}

$('#insightsTabs li a.nav-link').click(function () {
  $('#insightsTabs li').removeClass('active')

  $(this).parent().addClass('active')
})



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/scripts/yumiwi/tabs.js